"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMessageFlows = void 0;
const index_1 = require("../../Model/index");
const TypeFactory_1 = require("../TypeFactory");
function parseMessageFlows(data) {
    const messageFlowsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.MessageFlow);
    if (!messageFlowsRaw) {
        return [];
    }
    const messageFlows = [];
    for (const messageFlowRaw of messageFlowsRaw) {
        const messageFlow = (0, TypeFactory_1.createObjectWithCommonProperties)(messageFlowRaw, index_1.Model.GlobalElements.MessageFlow);
        messageFlow.name = messageFlowRaw.name;
        messageFlow.sourceRef = messageFlowRaw.sourceRef;
        messageFlow.targetRef = messageFlowRaw.targetRef;
        messageFlows.push(messageFlow);
    }
    return messageFlows;
}
exports.parseMessageFlows = parseMessageFlows;
//# sourceMappingURL=MessageFlowParser.js.map